import { render, staticRenderFns } from "./Laboratory.vue?vue&type=template&id=44e9bdd4&scoped=true&"
import script from "./Laboratory.vue?vue&type=script&lang=js&"
export * from "./Laboratory.vue?vue&type=script&lang=js&"
import style0 from "./Laboratory.vue?vue&type=style&index=0&id=44e9bdd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e9bdd4",
  null
  
)

export default component.exports